<template>
  <section id="skills" class="section skills" aria-labelledby="skills-title">
    <div class="container">
      <header class="section-heading">
        <p class="section-heading__index mono">04 / Technical range</p>
        <div class="section-heading__copy">
          <h2 id="skills-title">Range, with a center of gravity.</h2>
          <p>
            Enterprise .NET is the foundation. Cloud, web, identity, and game
            systems make up the range.
          </p>
        </div>
      </header>

      <div class="skills__grid">
        <section>
          <span class="skills__number mono">01</span>
          <h3>Architecture &amp; backend</h3>
          <p>C#, .NET, ASP.NET, Java, Node.js, Go, Rust, Bevy ECS</p>
        </section>
        <section>
          <span class="skills__number mono">02</span>
          <h3>Web &amp; application UI</h3>
          <p>Vue, Angular, AngularJS, Next.js, WPF, Episerver, DevExpress</p>
        </section>
        <section>
          <span class="skills__number mono">03</span>
          <h3>Cloud &amp; delivery</h3>
          <p>Azure, AWS, Kubernetes, Docker, DevOps</p>
        </section>
        <section>
          <span class="skills__number mono">04</span>
          <h3>Data, search &amp; identity</h3>
          <p>SQL, MongoDB, Elasticsearch, FIM / MIM</p>
        </section>
        <section>
          <span class="skills__number mono">05</span>
          <h3>Tooling &amp; scripting</h3>
          <p>Python content pipelines, Lua content scripting</p>
        </section>
        <section>
          <span class="skills__number mono">06</span>
          <h3>Product craft</h3>
          <p>UX, design systems, performance, maintainable interfaces</p>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Skills",
};
</script>

<style lang="scss" scoped>
.skills__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  background: var(--surface);
  box-shadow: var(--shadow-soft);
}

.skills__grid section {
  position: relative;
  min-height: 214px;
  padding: clamp(26px, 3vw, 38px);
  overflow: hidden;
  border-right: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  background: rgba(8, 13, 18, 0.35);
  transition: background 180ms ease;
}

.skills__grid section:nth-child(3n) {
  border-right: 0;
}

.skills__grid section:nth-child(n + 4) {
  border-bottom: 0;
}

.skills__grid section::after {
  content: "";
  position: absolute;
  right: -50px;
  bottom: -80px;
  width: 150px;
  height: 150px;
  border: 1px solid rgba(124, 226, 201, 0.08);
  border-radius: 50%;
  transition: border-color 180ms ease, transform 300ms ease;
}

.skills__grid section:hover {
  background: rgba(17, 27, 34, 0.72);
}

.skills__grid section:hover::after {
  border-color: rgba(124, 226, 201, 0.2);
  transform: scale(1.12);
}

.skills__number {
  display: block;
  margin-bottom: 44px;
  color: var(--accent-2);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.skills__grid h3 {
  margin-bottom: 10px;
  color: var(--text);
  font-size: 17px;
  font-weight: 660;
  letter-spacing: -0.025em;
}

.skills__grid p {
  max-width: 32ch;
  margin: 0;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.68;
}

@media (max-width: 820px) {
  .skills__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .skills__grid section:nth-child(3n) {
    border-right: 1px solid var(--border);
  }

  .skills__grid section:nth-child(2n) {
    border-right: 0;
  }

  .skills__grid section:nth-child(4) {
    border-bottom: 1px solid var(--border);
  }
}

@media (max-width: 520px) {
  .skills__grid {
    grid-template-columns: 1fr;
    border-radius: var(--radius-lg);
  }

  .skills__grid section {
    min-height: 180px;
    border-right: 0 !important;
    border-bottom: 1px solid var(--border) !important;
  }

  .skills__grid section:last-child {
    border-bottom: 0 !important;
  }

  .skills__number {
    margin-bottom: 30px;
  }
}
</style>
